import axios from "axios";
import { proxy } from "../config";

export const getRequests = async (id) => {
    return await axios.get(`${proxy}/forgot_password/`);
};

export const newPassword = async (id) => {
    return await axios.put(`${proxy}/forgot_password/new_password/${id}`, {});
};

export const deleteRequest = async (id) => {
    return await axios.delete(`${proxy}/forgot_password/delete/${id}`);
};